<ion-content appIonScrollbar [scrollbarWidth]="0">

  <ion-grid>
    <ion-row class="top-row">

      <ion-col size="12">
        <ion-text color="primary" class="ion-text-center">
          <h1>{{'Concierge' | translate}}</h1>
        </ion-text>
      </ion-col>

    </ion-row>

    <ion-row *ngIf="dataServ.rData">
      <ng-container *ngFor="let cat of dataServ.rData.other_services.menu_categories">
        <ng-container *ngFor="let item of cat.menu_items">
          
          <ion-col size="12">
            <!-- <ion-card (click)="detail(item, dataServ.rData.other_services)">
              <ion-img [src]="item.image_url" *ngIf="item.image_url"></ion-img>

              <div class="bottom">
                <ion-text color="white">
                  <h2><b [innerHtml]="item.name | caption | translate"></b></h2>
                </ion-text>
              </div>
            </ion-card> -->
            <app-menu-section-item [item]="item" (itemClick)="detail(item, dataServ.rData.other_services)"></app-menu-section-item>
          </ion-col>
        </ng-container>
      </ng-container>
    </ion-row>
  </ion-grid>


</ion-content>